import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=d34428fe&"
import script from "./Error.ts?vue&type=script&lang=ts&"
export * from "./Error.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports